/**
 * useHasHgForceEnabled will control whether or not
 * show hgforce integration around the platform, so that we have a single source of truth
 *
 * @returns boolean
 */

import { userHasClaims, hgForceEnabled } from "../utils/auth";

export const useHasHgForceEnabled = () => {
  return userHasClaims([hgForceEnabled]);
};
